
import {Component, OnInit, TemplateRef} from '@angular/core';
import {puissance, tarif} from "../../../../model/db";
import {ActivatedRoute} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {valuesys} from "../../../../../../options";
import Swal from 'sweetalert2' ;
import {Translatable} from "../../../../../Translatable";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {environment} from "../../../../../../environments/environment";
import * as $ from "jquery";

@Component({
  selector: 'app-puissance',
  templateUrl: './puissance.component.html',
  styleUrls: ['./puissance.component.css']
})
export class PuissanceComponent extends Translatable implements OnInit {

  title:string ;
  dtOptions: DataTables.Settings = {};

  titleModal:string ;
  //titleProfilage:string=this.__('profil.profils') ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  modalRef: BsModalRef;
  public activite: string;
  public activiteSelected:string;
  public selectedIDTarif: number;



  public puissances:puissance [] = [];
  public tarifs:tarif [] = [];
  public puissance:puissance  = new  puissance();
  puissance_error: puissance;
  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService
  ) {
    super();
  }
  async ngOnInit() {
    this.auth.initAutority("PUIS");


    this.isAdd = true ;
    this.isValid = false ;
    this.title = this.__("lebel_users");
    this.initDatatable()
    //console.log(" liste des droits "+this.listeModules);


  }

  initDatatable(){
    this.dtOptions = this.helper.dataTableOption();
    this.dtOptions.columns = [
        {
            "data": "value"
        },
        {
            "data": "tarif",
            "name" : "tarif.value",
        }

    ]  ;
    this.dtOptions.ajax = (dataTablesParameters: any, callback) => {
      this.http
          .get<DataTablesResponse>(
              environment.puissance +"?child=tarif&" + $.param(dataTablesParameters), valuesys.httpAuthOptionsProcess()
          ).subscribe(resp => {
        this.puissances = resp.data;
        callback({
          recordsTotal: resp.recordsTotal,
          recordsFiltered: resp.recordsFiltered,
          data:[]
        });
      });
    }
  }

  async addUserForm(){
    this.isValid = true ;
    if(this.isAdd ){
      console.log(this.puissance);
      let res =  await this.http.post<any>( environment.puissance,this.puissance,valuesys.httpAuthOptions()).toPromise();
      if(res.code === 201){
        this.toastr.success(res.msg,this.__("msg.success")) ;
          res.data.tarif = this.tarifs.find(_ => _.id == this.puissance.tarif_id) ;
        this.puissances.push(res.data);
        this.close()
      }else if(res.code === 400){
        this.puissance_error = <puissance> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }else {

      let res =  await this.http.put<any>( environment.puissance + '/' + this.puissance.id,this.puissance,valuesys.httpAuthOptions()).toPromise();
      console.log("res",res)
      if(res.code === 201){
        this.puissance.tarif = this.tarifs.find((_) =>_.id == this.puissance.tarif_id);
       this.toastr.success(res.msg,this.__("msg.success")) ;

        this.close()
      }else if(res.code === 400){
        this.puissance_error = <puissance> this.helper.errorForm(res.data);
        this.toastr.warning(res.msg,this.__("msg.warning")) ;
      }
      else {
        this.toastr.error(res.msg,this.__("msg.error")) ;
      }
    }
    this.isValid = false ;

  }
  async openModal(template: TemplateRef<any>,currenTypePiece:puissance =null,btn:any) {
    btn.disabled= true
    this.puissance_error = new puissance();
      if(currenTypePiece == null){
      this.puissance = new puissance();
      this.isAdd = true ;
      this.titleModal = this.__('puissance.add') ;
    }else {
      this.isAdd = false ;
      this.titleModal = this.__('puissance.edit') ;
     this.puissance = currenTypePiece ;
        if (currenTypePiece.tarif != null) {
          this.selectedIDTarif = currenTypePiece.tarif_id;
          this.activiteSelected=currenTypePiece.tarif.activite;
        this.onChangeActivite();


        } else {
          this.tarifs = null;
        }

      }
    btn.disabled= false

    this.modalRef = this.modalService.show(template,{ignoreBackdropClick:true});
  }
  close(){
    this.puissance_error = new puissance();
    this.puissance = new puissance();
    this.titleModal = "" ;
    this.modalRef.hide()
  }
  delete(deleteTypePiece:puissance,btn:any){
    btn.disabled= true
    Swal.fire({
      title: this.__('msg.confirm'),
      text: this.__('msg.warning_delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.__('msg.confirmed_delete'),
      cancelButtonText: this.__('msg.cancel_delete')
    }).then(async (result) => {
      if (result.value) {
        let sup = await this.http.delete<any>(environment.puissance+"/"+deleteTypePiece.id,valuesys.httpAuthOptions()).toPromise();
        if(sup.code == 204){
          this.puissances= this.puissances.filter(function (item,index) {
            return item.id != deleteTypePiece.id
          });
          btn.disabled= false
          Swal.fire(
              this.__('msg.deleted'),
              sup.msg,
              'success'
          )
        }else {
          btn.disabled= false
          this.toastr.error(sup.msg,this.__("msg.error"));
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
            this.__('msg.canceled'),
            this.__('msg.canceled_delete'),
            'error'
        )
        btn.disabled= false
      }
    })
  }


  async toggleState(type:puissance,state:number,btn:any){
    console.log(btn.hidden = true)
    $(btn).attr('disabled');
    btn.disabled = true;
    let toogle = await this.http.get<any>( environment.puissance+`/${type.id}/${state}/state`,valuesys.httpAuthOptions()).toPromise();
    if(toogle.code == 201){
      this.toastr.success(toogle.msg,this.__("msg.success"));
      type.state = toogle.data.state

    }else {
      this.toastr.error(toogle.msg,this.__("msg.error"));
    }
    btn.disabled = false;
  }


  async onChangeActivite() {
    let res_tarifs= await this.helper.getSelectList( environment.tarif + `?where=activite|e|${this.activiteSelected}`, ['value']);
    // console.log('regions: ', this.tarifs);
    if (res_tarifs) {
      this.tarifs = res_tarifs;
      // console.log(' this.tarifschane activite: ', this.tarifs);

    }
  }


}

